<template>
  <section class="template-multi-section-catalog">
    <div
      v-if="catalogInfo && isVisible"
      :id="`multi_section_index_${multisectionIndex}`"
      ref="onDisplay"
      :class="multiSectionClass"
    >
      <CatalogBandTitle :section-info="sectionInfo" />
      <lazy-component @show="setData">
        <CellList
          v-if="!isEmptyCellList"
          :cell-list="cellList"
          :title="multiSectionTitle"
          :thumbnail-info="thumbnailInfo"
        />
      </lazy-component>
      <CatalogViewMoreButton :section-info="sectionInfo" />
    </div>
  </section>
</template>
<script setup>
  import { ref, computed } from 'vue'
  import { convertBand } from '@/common/converter/convert-band'
  import { useEventOnDisplay } from '@/common/use/useEventOnDisplay'
  import CatalogBandTitle from '@/components/catalog/CatalogBandTitle.vue'
  import CellList from '@/components/band/CellList.vue'
  import CatalogViewMoreButton from '@/components/view-more/CatalogViewMoreButton.vue'

  const props = defineProps({
    catalogInfo: {
      type: Object,
      default: () => {},
    },
    sectionInfo: {
      type: Object,
      default: null,
    },
    thumbnailInfo: {
      type: Object,
      default: () => {},
    },
    multisectionIndex: {
      type: Number,
      default: 0,
    },
  })

  const onDisplay = ref(null)
  useEventOnDisplay(onDisplay, props.sectionInfo)

  const multiSectionTitle = computed(() => props.sectionInfo?.title ?? '')
  const multiSectionClass = computed(() => {
    const type = props.thumbnailInfo?.type ?? ''
    return type === 'band_94' || type === 'band_98'
      ? `multi portrait-cell ranking-band`
      : `multi ${props.thumbnailInfo?.componentName ?? ''}`
  })
  const cellList = ref([])
  const isVisible = ref(true)
  const band = ref({})
  const isEmptyCellList = computed(() => cellList.value.length === 0)

  const setVisibleState = () => {
    isVisible.value = !isEmptyCellList.value
  }

  const setData = async () => {
    try {
      band.value = await convertBand(props.catalogInfo)
      cellList.value = band.value?.band?.celllist ?? []

      setVisibleState()
    } catch (e) {
      isVisible.value = false
    }
  }
  setData()
</script>
<style lang="scss" scoped>
  .multi {
    width: auto;
    .title {
      padding: 0 100px;
    }
    .swiper-button-prev,
    .swiper-button-next {
      left: 70px;
      opacity: 0;
    }
    .swiper-button-next {
      left: auto;
      right: 70px;
    }
    &.landscape-cell {
      min-height: 238px;
    }
    &.circle-cell {
      min-height: 202px;
    }
    &.portrait-cell {
      min-height: 496px;
    }
    &.editor-pick-package-cell {
      min-height: 366px;
      padding: 0;
    }
    &.image-box-cell {
      min-height: 208px;
    }
    &.landscape-ranking-cell {
      min-height: 449px;
    }

    &.autoplay-band {
      min-height: 421px;
    }
    .btn-more {
      right: 100px;
    }
  }
</style>
